import * as React from "react"
import { useState, useEffect } from 'react'
import { graphql, Link } from "gatsby"
import { Seo } from "../../components/seo"
import { Layout } from "../../components/layout"
import ShopifyRichText from "../../utils/ShopifyRichTextToHTML"
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { newsContainer, fullContainer, newsContentContainer, containered, column1, column2, authorClass, golden, socialShare, recentNews, RecentBlogImage, RecentBlogheading, Tags, recentNewsVertical, sliderBlog, FeaturedNewsTag, blogTitle, minTagHeight, overlaytext, imagecontainer, overlayHR, blueDarkbutton, emContainer, weight, sticky, stickyFlexTwo, stickyFlexOne, stickyClose, stickyColumn, ScrollableSection, RecentadsImage, blogFeaturedImage, marg } from "./news-article.module.css"
import { DarkButton } from "../../components/buttons/dark-button"
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquareXTwitter, faFacebookSquare, faLinkedin } from '@fortawesome/free-brands-svg-icons'

export default function News({ data, pageContext }) {
    // Custom component for Previous Arrow
    const PrevArrow = (props) => {
      const { onClick } = props;
      return <button onClick={onClick} className="custom-slick-prev">&larr;</button>;
    };

  // Custom component for Next Arrow
    const NextArrow = (props) => {
      const { onClick } = props;
      return <button onClick={onClick} className="custom-slick-next">&rarr;</button>;
    };

        const sliderSettings = {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          adaptiveHeight: true,
          autoplay: true,
          dots: true,
          speed: 1000,
          autoplaySpeed: 10000,
          draggable: true,
          pauseOnFocus: false,
          pauseOnHover: false,
          prevArrow: <PrevArrow />,
          nextArrow: <NextArrow />,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                infinite: true,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                infinite: true,
              }
            }
          ]
        };

  const { handle } = pageContext; 

  const maxTitleLength = 60;
  
  //get recent 3 blogs
  const allArticles = data.storefront.articles.nodes;
  const filteredNews = data.storefront.articles.nodes.filter((node) => node.handle === handle);
  const filteredArticles = allArticles.filter((article) => article.handle !== pageContext.handle);
  const [relatedArticles, setRelatedArticles] = useState([]);

  const [currentUrl, setcurrentUrl] = useState('');

  useEffect(() => {
    setcurrentUrl(window.location.href);
    // Sort filteredArticles by publication date in descending order
    const sortedArticles = filteredArticles.sort((a, b) => {
      return new Date(b.publishedAt) - new Date(a.publishedAt);
    });
    // Select the most recent 3 articles
    const mostRecentThreeArticles = sortedArticles.slice(0, 3);
    setRelatedArticles(mostRecentThreeArticles);
  }, []);

  if (!filteredNews || filteredNews.length === 0) {
    return <Layout>News not found</Layout>;
  }

  const contentHtml = filteredNews[0].contentHtml;
  // const excerptHtml = filteredNews[0].excerptHtml;
  // const newsHandle = filteredNews[0].handle;
  // const articleId = filteredNews[0].id;
  const imageUrl = filteredNews[0].image && filteredNews[0].image.url;
  // const onlineStoreUrl = filteredNews[0].onlineStoreUrl;
  const formatDate = (dateString) => {
    const options = { 
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    const formattedDate = new Date(dateString).toLocaleDateString('en-US', options);
    return formattedDate;
  };
  
  const publishedAt = filteredNews[0].publishedAt;
  const publishedDate = new Date(publishedAt);
  const options = { 
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  const formattedDate = publishedDate.toLocaleDateString('en-US', options);
  const tags = filteredNews[0].tags;
  const title = filteredNews[0].title;
  const authorName = filteredNews[0].authorV2 && filteredNews[0].authorV2.name;
  const metafields = filteredNews[0].metafields;

  // console.log("All Authors:", data.storefront.authors.edges);
  const authors = data.storefront.authors.edges; 

const [isStickyVisible, setIsStickyVisible] = useState(false);

const [isStickyManuallyClosed, setIsStickyManuallyClosed] = useState(false);

const handleScroll = () => {
  const scrollPosition = window.scrollY || window.pageYOffset;
  const pageHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  const scrollPercentage = (scrollPosition / pageHeight) * 100;

  if (!isStickyManuallyClosed) {
    setIsStickyVisible(scrollPercentage >= 50);
  }
};

const handleClose = () => {
  setIsStickyVisible(false);
  setIsStickyManuallyClosed(true); // Marking that sticky has been manually closed
  window.removeEventListener('scroll', handleScroll);
};

useEffect(() => {
  handleScroll();

  window.addEventListener('scroll', handleScroll);

  return () => {
    window.removeEventListener('scroll', handleScroll);
  };
}, [isStickyManuallyClosed]);

  const stickyStyles = {
    display: isStickyVisible ? 'flex' : 'none',
  };


  return (
    <Layout>
      <div className={fullContainer}>
      {filteredNews[0].metafields && filteredNews[0].metafields.length > 0 && filteredNews[0].metafields.some(metafield => metafield && metafield.key === 'sticky_message') && (
        <div className={`${sticky} ${isStickyVisible ? 'visible' : 'hiddenOne'}`} style={stickyStyles}>
          <div className={stickyFlexOne}>
            {filteredNews[0].metafields.map(metafield => (
              metafield && metafield.key === 'sticky_message' && metafield.reference && metafield.reference.stickylabel && metafield.reference.stickyurl && (
                <div key={metafield.id}>
                  <ShopifyRichText richTextData={metafield.reference.stickylabel.value} />
                </div>
              )
            ))}
          </div>
          <div className={stickyFlexTwo}>
            {filteredNews[0].metafields.map(metafield => (
              metafield && metafield.key === 'sticky_message' && metafield.reference && metafield.reference.stickylabel && metafield.reference.stickyurl && (
                <div key={metafield.id}>
                  <a href={metafield.reference.stickyurl.value} target="_blank" rel="noopener noreferrer">&rarr;</a>
                </div>
              )
            ))}
          </div>
          <span className={stickyClose} onClick={handleClose}>&times;</span>
        </div>
      )}
      <div className={newsContainer}> 
        <div className={imagecontainer}>
          {imageUrl && (
            <img src={imageUrl} alt="Image" className={blogFeaturedImage}  />
          )}
          <div className={overlaytext}>
              {title && (
                <h1 className={blogTitle}>{title}</h1>
              )}
              <br/>
              <hr className={overlayHR}/>
              <br/>
              {tags && (
                <p className={FeaturedNewsTag}>{tags.join(', ')}</p>
              )}
          </div>
        </div>    

      <div className={containered}>
        <div className={column1}>   
          <div className={sliderBlog}>
              {contentHtml && (
                <ShopifyRichText richTextData={contentHtml} />
              )}  
              <br />
          <br />
            <Slider {...sliderSettings}>
              {metafields.map((metafield) => (
                metafield && metafield.references && Array.isArray(metafield.references.nodes) &&
                metafield.references.nodes.map((node) => (
                  node && (
                    <img key={node.id} src={node.image.url} alt={node.image.altText}  />
                  )
                ))
              ))}
          </Slider>
          <br/>
          </div>
        </div>
            
        <div className={`${column2} ${stickyColumn}`}>
            <div className={golden}>
            <div><em>Published on {formattedDate}</em></div>
              {authors.map(author => {
                if (author.node.fields && author.node.fields[1] && author.node.fields[2]) {
                  const authorFullName = `${author.node.fields[1].value} ${author.node.fields[2].value}`;
                  if (authorName === authorFullName) {
                    return (
                      <div key={author.node.id}>
                        <Link to={`/author/${author.node.handle}`} rel="alternate" hrefLang="en-SG" >
                        <div className={authorClass}>{authorFullName}</div>
                        </Link>
                        <ShopifyRichText richTextData={author.node.fields[0].value} />
                        {/* <Link to={`/author/${author.node.handle}`} rel="alternate" hrefLang="en-SG">
                        <u><div className={authorClassSub}>MORE FROM THE AUTHOR &rarr;</div></u>
                        </Link> */}
                        <DarkButton
                            to={`/author/${author.node.handle}`}
                            className={blueDarkbutton}
                          >
                            MORE FROM THE AUTHOR &rarr;
                          </DarkButton>
                      </div>
                    );
                  }
                }
                return null; 
              })}
              <br/>
            </div>
            
            <div className={socialShare}>
            <span style={{padding: '16px 0px'}}>Share article on</span>
              <FacebookShareButton url={currentUrl}>
                        <FontAwesomeIcon icon={faFacebookSquare} style={{ color: '#D2C7A1', fontSize: '30px', padding: '6px' }} />
                </FacebookShareButton>
                <TwitterShareButton url={currentUrl}>
                        <FontAwesomeIcon icon={faSquareXTwitter} style={{ color: '#D2C7A1', fontSize: '30px', padding: '6px' }} />
                </TwitterShareButton>
                <LinkedinShareButton url={currentUrl}>
                        <FontAwesomeIcon icon={faLinkedin} style={{ color: '#D2C7A1', fontSize: '30px', padding: '6px' }} />
                </LinkedinShareButton>
            </div>
            <hr/>
            <br/>
            <div className={recentNewsVertical}>
              {/* <div style={{ flex: "1", margin: "10px 0px", border: "1px rgb(198, 198, 198) solid", padding: "20px" }}>
              <img src="https://cdn.shopify.com/s/files/1/0823/1606/7107/files/gallery.png?v=1701664448"  className={RecentadsImage}  />
              <div>
                <p>  
                   Have you visted our Gallery at <strong className={weight}>One Holland Village?</strong>
                </p>
                </div>
                  <DarkButton
                    to={`https://www.google.com/maps?q=One+Holland+Village,+7+Holland+Village+Way+#01-10/11,+Singapore+275748`}
                    className={blueDarkbutton}
                    target="_blank"
                  >
                    Get Directions &rarr;
                  </DarkButton>
                  <div>
                  </div>
                  <br></br>
                </div> */}
                <div style={{ flex: "1", margin: "10px 0px", border: "1px rgb(198, 198, 198) solid", padding: "20px" }}>
              <img src="https://cdn.shopify.com/s/files/1/0823/1606/7107/files/Marylin_800x450_d1241bb4-9007-41fa-b580-049dd17d92ba.jpg?v=1708050492" className={RecentadsImage}  />
              <div>
                <p>  
                   Consider art as a part of your <strong className={weight}>Investment Portfolio</strong>
                </p>
                </div>
                  <DarkButton
                    to={`/news/`}
                    className={blueDarkbutton}
                  >
                    Learn More &rarr;
                  </DarkButton>
                  <div>
                  </div>
                  <br></br>
                </div>
            </div>
            <div className={`${ScrollableSection}`}>
              </div>
            </div>
          </div>
      <br/>  
      </div>
      <div className={newsContentContainer}>
      <br />
      <h1><strong>RECENT NEWS</strong></h1>
      <br />
      <div className={recentNews}>
        {relatedArticles
        .filter(article => !article.tags.includes("Events"))
        .map(article => (
          <div key={article.handle} className={marg} style={{ flex: "1"}}>
            {article.image && (
              <Link to={`/news/${article.handle}`}
              aria-label={`View ${article.handle} news page`}>
              <img src={article.image.url} alt={article.title} className={RecentBlogImage}  />
              </Link>
            )}
            <div className={minTagHeight}>
            {article.tags && (
              <div className={Tags}>{article.tags.join(', ')}</div>
            )}
            </div>
            <Link to={`/news/${article.handle}`}
              aria-label={`View ${article.handle} news page`}>
            <h3 className={RecentBlogheading}>
              {article.title}
            </h3>
            </Link>
            {article.authorv2 && (
              <div>{article.authorv2}</div>
            )}
            {article.excerptHtml && (
              <div>
                <p>{article.excerptHtml.split(' ').slice(0, 20).join(' ')}{article.excerptHtml.split(' ').length > 20 ? '...' : ''}</p>
              </div>
            )}
            <p className={emContainer}>{formatDate(article.publishedAt)}</p>
           <DarkButton
                    to={`/news/${article.handle}`}
                    aria-label={`View ${article.handle} news page`}
                    className={blueDarkbutton}
                  >
                    Read more &rarr;
            </DarkButton>
          </div>
        ))}
      </div>
      </div>
      </div>
    </Layout>
  )
}

export const Head = ({ data, pageContext }) => {
  const currentNewsHandle = pageContext.handle;
  const currentNews = data.storefront.articles.nodes.find(article => article.handle === currentNewsHandle);
  const seoTitle = currentNews?.seo?.title || currentNews?.title || "Art Works Advisory News";
  const seoDescription = currentNews?.seo?.description || currentNews?.excerptHtml || "Art Work Advisory News description";
  const imageUrl = currentNews?.image?.url || ''; 
  const authorName = currentNews?.authorV2?.name || 'Art Works Advisory';
  const pDate = currentNews?.publishedAt;
  // console.log("author", authorName);
  // console.log("blog image", imageUrl);
  // console.log("published date", pDate);

  return (
    <>
      <Seo
        title={seoTitle}
        description={seoDescription}
        image={imageUrl} 
        author={authorName}
        publishDate={pDate}
      />
    </>
  );
};


export const query = graphql`
  query NewsQuery {
    storefront {
      authors: metaobjects(type: "author", first: 250) {
        edges {
          node {
            id
            handle
            type
            fields {
              key
              value
              reference {
                ... on Storefront_MediaImage {
                  id
                  image {
                    altText
                    height
                    url
                    width
                  }
                }
              }
            }
          }
        }
      }
      articles(first: 250) {
        nodes {
          contentHtml
          excerptHtml
          handle
          id
          image {
            url
            id
            altText
            height
            width
          }
          onlineStoreUrl
          publishedAt
          tags
          title
          seo {
            description
            title
          }
          authorV2 {
            name
          }
          excerpt
          metafields(identifiers: [{key: "image_uploads", namespace: "custom"}, {key: "sticky_message", namespace: "custom"}] ) {
            description
            id
            createdAt
            key
            namespace
            type
            value
            reference {
              ... on Storefront_Metaobject {
                id
                stickylabel: field(key: "sticky_context_label") {
                  value
                }
                stickyurl: field(key: "sticky_context_url") {
                  value
                }
              }
            }
            references(first:250) {
              nodes {
                ... on Storefront_MediaImage {
                  id
                  image {
                    url
                    id
                    altText
                  }
                }
                ... on Storefront_Metaobject {
                  id
                  fields {
                    value
                    type
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  
`